import { useLanguage } from "../../../config/localization/LanguageProvider";
import { Button } from "../../ui";
import userProfileService from "../../../features/users/services/user.service";
import localization from "../../../config/localization";
import { commonService } from "../../../services/common.service";
import { useEffect, useState } from "react";
import { MasterLanguageDropdownData } from "../../../models/Response/masterLanguageDropdownResponse";
import { useAppDispatch } from "../../../store/hooks";
import { updateUserLanguage } from "../../../features/users/reducers/userProfileReducer";

export function SidebarLanguageSwitcher({ isAuthenticated }: { isAuthenticated: boolean }) {
  const { language, setLanguage } = useLanguage();
  const [masterLanguageDropdown, setMasterLanguageDropdown] = useState<MasterLanguageDropdownData>();
  const dispatch = useAppDispatch();

  const handleUpdateUserLanguage = async (languageCode: string) => {
    setLanguage(languageCode);
    if (isAuthenticated) {
      await userProfileService.updateUserLanguage(languageCode);
      dispatch(updateUserLanguage(languageCode));
    }
  };

  useEffect(() => {
    const fetchMasterLanguageDropdown = async () => {
      const response = await commonService.fetchMasterLanguageDropdown();
      if (response.isSuccess) {
        setMasterLanguageDropdown(response.data ?? undefined);
      }
    }

    fetchMasterLanguageDropdown();
  }, []);

  return (
    <div className="sticky bottom-0 w-full bg-[#0F0F0F] p-5 flex justify-between items-center border-t border-[#2E2E2E] z-10">
      <span className="text-sm text-gray-400">
        {localization.change_language}
      </span>

      <div className="flex bg-black border border-[#333] rounded-full overflow-hidden">
        {masterLanguageDropdown?.details
          ?.sort((a, b) => a.code.localeCompare(b.code))
          .map((item) => (
            <Button
              key={item.id}
              className={`px-4 py-2 rounded-full text-sm min-w-[80px]
                ${language === item.code
                  ? "bg-white text-red-600"
                  : "text-gray-400"
                }`}
              onClick={() => handleUpdateUserLanguage(item.code)}
            >
              {item.name}
            </Button>
          ))}
      </div>
    </div>
  );
}